<template>
  <!-- 附件上传弹窗 -->
  <div class="upload-file-dialog">
    <base-dialog
      customClass="dialog-custom"
      ref="uploadFileDialogRef"
      :determineText="'确认'"
      @determine="determine()"
      @cancel="cancel()"
      :title="title"
      :pagination="false"
    >
      <div class="container">
        <FileUploadMultiple
          v-on="$listeners"
          :horizontal="horizontal"
          :tip="tip"
          :multiple="multiple"
          :limit="limit"
          :accept="accept"
          @getFileList="getFileList"
          :fileArr="fileArr"
        ></FileUploadMultiple>
      </div>
    </base-dialog>
  </div>
</template>

<script>
export default {
  name: "FileUploadDialog",
  props: {
    title: {
      type: String,
      default: "上传"
    },
    size: {
      type: Number,
      default: 5 * 1024 * 1024
    },
    fileArr: {
      type: Array,
      default: () => []
    },
    uploadwidth: {
      type: Number,
      default: 480
    },
    tip: {
      type: String,
      default: "支持jpg、jpeg、png格式，不大于5M"
    },
    accept: {
      type: String,
      default: ".jpg,.jpeg,.JPG,.JPEG,.png,.PNG"
    },
    multiple: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 5
    },
    horizontal: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isZoomInPreview: {
      type: Boolean,
      default: false
    },
    ifCanDelete: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      btns: [""],
      customerId: this.$route.params.customerId,
      fileList: []
    };
  },
  created() {},
  async mounted() {},
  activated() {},
  computed: {},
  methods: {
    // 打开弹窗
    async showdialog() {
      this.$refs.uploadFileDialogRef.show(true);
      this.$nextTick(() => {
        this.fileList = this.fileArr;
      });
    },
    getFileList(fileList) {
      this.fileList = fileList;
    },
    // 确定
    async determine() {
      this.$emit("getFileListDetmine", this.fileList);
      this.$refs.uploadFileDialogRef.show(false);
    },
    // 关闭弹窗回调
    close() {
      Object.assign(this.$data, this.$options.data.call(this));
    },
    // 取消
    cancel() {
      this.$refs.uploadFileDialogRef.show(false);
    }
  }
};
</script>

<style lang="less" scoped>
// /deep/.el-scrollbar__wrap {
//   margin-right: -100px !important;
// }
.upload-file-dialog {
  .container {
    padding: 20px;
  }
  :deep(.dialog-custom .el-dialog) {
    min-width: 520px !important;
    width: 520px !important;
  }
}
</style>

<style lang="less"></style>
